import { NotificacoesModel } from './model/NotificacoesModel';

import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { AppStorage } from './AppStorage';
import { AppSession } from './AppSession';
import { ContratoModel } from './model/ContratoModel';
import { ChaveContratoEnum } from './ChaveContratoEnum';
const fcm = FCM;

export class FirebaseWrapper {

    static async trataRetornoPreferenciasNotificacao(notificacoesModel: NotificacoesModel): Promise<NotificacoesModel> {
        notificacoesModel.notificacoes_curto_prazo_brasil = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_curto_prazo_brasil)
        notificacoesModel.notificacoes_medio_prazo_brasil = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_medio_prazo_brasil)
        notificacoesModel.notificacoes_longo_prazo_brasil = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_longo_prazo_brasil)
        notificacoesModel.notificacoes_curto_prazo_eua = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_curto_prazo_eua)
        notificacoesModel.notificacoes_medio_prazo_eua = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_medio_prazo_eua)
        notificacoesModel.notificacoes_longo_prazo_eua = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_longo_prazo_eua)
        notificacoesModel.notificacoes_curto_prazo_cripto = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_curto_prazo_cripto)
        notificacoesModel.notificacoes_medio_prazo_cripto = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_medio_prazo_cripto)
        notificacoesModel.notificacoes_longo_prazo_cripto = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_longo_prazo_cripto)
        notificacoesModel.notificacoes_carteira_recomendada = await FirebaseWrapper.setTrueIsPlanWalletRecommendation(notificacoesModel.notificacoes_carteira_recomendada)
        notificacoesModel.notificacoes_opcoes = FirebaseWrapper.setTrueIsUndefined(notificacoesModel.notificacoes_opcoes)
        return notificacoesModel
    }

    private static setTrueIsUndefined(channel): boolean {
        return channel === undefined ? true : channel
    }

    private static async setTrueIsPlanWalletRecommendation(channel): Promise<boolean> {
        const resultContrato = await AppStorage.get(AppSession.CHAVE_CONTRATO_USUARIO)
        const hasAPlanEnabled = ContratoModel.existeContratoPorChave(ChaveContratoEnum.CONTRATO_CARTEIRA_RECOMENDADA, resultContrato.contratos)
        return channel === undefined ? hasAPlanEnabled : channel
    }

    configuraTopicsFirebase(notificacoesModel: NotificacoesModel) {
        this.subscribeToNotification(notificacoesModel.notificacoes_curto_prazo_brasil, 'notificacoes_curto_prazo_brasil')
        this.subscribeToNotification(notificacoesModel.notificacoes_medio_prazo_brasil, 'notificacoes_medio_prazo_brasil')
        this.subscribeToNotification(notificacoesModel.notificacoes_longo_prazo_brasil, 'notificacoes_longo_prazo_brasil')
        this.subscribeToNotification(notificacoesModel.notificacoes_curto_prazo_eua, 'notificacoes_curto_prazo_eua')
        this.subscribeToNotification(notificacoesModel.notificacoes_medio_prazo_eua, 'notificacoes_medio_prazo_eua')
        this.subscribeToNotification(notificacoesModel.notificacoes_longo_prazo_eua, 'notificacoes_longo_prazo_eua')
        this.subscribeToNotification(notificacoesModel.notificacoes_curto_prazo_cripto, 'notificacoes_curto_prazo_cripto')
        this.subscribeToNotification(notificacoesModel.notificacoes_medio_prazo_cripto, 'notificacoes_medio_prazo_cripto')
        this.subscribeToNotification(notificacoesModel.notificacoes_longo_prazo_cripto, 'notificacoes_longo_prazo_cripto')
        this.subscribeToNotification(notificacoesModel.notificacoes_carteira_recomendada, 'notificacoes_carteira_recomendada')
        this.subscribeToNotification(notificacoesModel.notificacoes_opcoes, 'notificacoes_opcoes')

        // Desinscrever o usuário desses canais antigos
        fcm.unsubscribeFrom({ topic: 'notificacoes_operacoes_no_dia' });
        fcm.unsubscribeFrom({ topic: 'notificacoes_curto_prazo' })
        fcm.unsubscribeFrom({ topic: 'notificacoes_longo_prazo' })

        // if (notificacoesModel.operacoesNoDia) {
        //     PushNotifications.register()
        //         .then((data) => {
        //             console.log("success subscribeTo: " + JSON.stringify(data))
        //             fcm.subscribeTo({ topic: 'notificacoes_operacoes_no_dia' })
        //         })
        //         .catch((err) => console.log("Erro subscribeTo: " + JSON.stringify(err)));
        // } else {
        //     fcm.unsubscribeFrom({ topic: 'notificacoes_operacoes_no_dia' })
        // }
        // if (notificacoesModel.curtoPrazo) {
        //     PushNotifications.register()
        //         .then((data) => {
        //             console.log("success subscribeTo: " + JSON.stringify(data))
        //             fcm.subscribeTo({ topic: 'notificacoes_curto_prazo' })
        //         })
        //         .catch((err) => console.log("Erro subscribeTo: " + JSON.stringify(err)));
        // } else {
        //     fcm.unsubscribeFrom({ topic: 'notificacoes_curto_prazo' })
        // }
        // if (notificacoesModel.longoPrazo) {
        //     PushNotifications.register()
        //         .then((data) => {
        //             console.log("success subscribeTo: " + JSON.stringify(data))
        //             fcm.subscribeTo({ topic: 'notificacoes_longo_prazo' })
        //         })
        //         .catch((err) => console.log("Erro subscribeTo: " + JSON.stringify(err)));
        // } else {
        //     fcm.unsubscribeFrom({ topic: 'notificacoes_longo_prazo' })
        // }
    }

    async subscribeToNotification(notificationFlag: boolean, topic: string) {
        if (notificationFlag) {
            PushNotifications.register()
                .then((data) => {
                    console.log("success subscribeTo: " + JSON.stringify(data))
                    console.log("success subscribeTo: " + topic)
                    fcm.subscribeTo({ topic })
                })
                .catch((err) => console.log("Erro subscribeTo: " + JSON.stringify(err)));
        } else {
            fcm.unsubscribeFrom({ topic })
        }
    }

    configuraTopicsFirebaseAdmin(idAdmin: boolean) {
        if (idAdmin) {
            PushNotifications.register()
                .then((data) => {
                    console.log("success subscribeTo: " + JSON.stringify(data))
                    fcm.subscribeTo({ topic: 'notificacoes_admin' })
                })
                .catch((err) => console.log("Erro subscribeTo: " + JSON.stringify(err)));
        } else {
            fcm.unsubscribeFrom({ topic: 'notificacoes_admin' })
        }
    }

    async getToken() {
        return await fcm.getToken()
    }
}